<template>
    <div class="page-container">
        <div class="page-title">
            已推荐：<span>{{pageData.highPartner}}位高级合伙人</span> <span>{{pageData.partner}}位初级合伙人</span>
        </div>
        <div class="page-bottom">
            <div class="reward-tab">
                <div class="tab-item" :class="{actived : currentTab == 2}" @click="changeTab(2)">高级合伙人</div>
                <div class="tab-item" :class="{actived : currentTab == 1}" @click="changeTab(1)">初级合伙人</div>
            </div>
            <div class="reward-list">
                <!-- 表头 -->
                <div class="reward-item" style="color:#3088F5;">
                    <div class="col1">时间</div>
                    <div class="col2">姓名</div>
                    <div class="col3">手机号</div>
                </div>
                <div class="reward-item" v-for="(item,index) in list" :key="index">
                    <div class="col1">{{item.createTime | createtimeNotime}}</div>
                    <div class="col2">{{item.userName}}</div>
                    <div class="col3">{{item.mobile}}</div>
                </div>
                <div class="see-more">没有更多了～</div>
            </div>
        </div>
    </div>
</template>
<script>
import $http from '@/lib/request'
import config from '@/config'
import {Toast} from 'vant'

export default {
    data(){
        return {
            currentTab:2,//2 高级合伙人，1 合伙人
            page:1,
            limit:50,
            pageData:{},
            list:[]
        }
    },
    components:{
        [Toast.name]:Toast
    },
    activated(){
        this.getData();
    },
    methods:{
        getData(){
            $http({
                method:'post',
                data:{
                    type:this.currentTab,
                    page:this.page,
                    limit:this.limit
                },
                url:config.api.recommendList
            }).then(res=>{
                if(res.errno == 0){
                    this.pageData=res.data;
                    this.list=res.data.list;
                }else{
                    Toast(res.errmsg)
                }
            })
        },
        toggleSee(){
            this.totalStockSee=!this.totalStockSee;
        },
        changeTab(type){
            this.currentTab=type;
            this.list=[];
            this.getData();
        }
    }
}
</script>
<style lang="scss" scoped>
@mixin one-line{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
@mixin flex-between{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.page-container{
    background:#f5f5f5;
    min-height: 100vh;
    box-sizing: border-box;
    padding:10px;
    .page-title{
        font-size: 14px;
        color:#666;
        line-height: 20px;
        margin:10px 0;
        &>span{
            margin-right: 10px;
        }
    }
    .page-bottom{
        .reward-tab{
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            .tab-item{
                width:160px;
                height:40px;
                line-height: 40px;
                text-align: center;
                background:#fff;
                font-size: 15px;
                position: relative;
                @media screen and (max-width: 750px){
                    border-radius: 6px 6px 0px 0px;
                }
                z-index: 1;
                &:first-child{
                    &::after{
                        content:'';
                        display: block;
                        width: 0;
                        height: 0;
                        border-style: solid;
                        border-width: 36px 0 0 20px;
                        border-color: transparent transparent transparent #fff;
                        position: absolute;
                        right:-19px;
                        bottom:0;
                    }
                }
                &:last-child{
                    &::after{
                        content:'';
                        display: block;
                        width: 0;
                        height: 0;
                        border-style: solid;
                        border-width: 0 0 36px 20px;
                        border-color: transparent transparent #fff transparent;
                        position: absolute;
                        left:-19px;
                        bottom:0;
                    }
                }
                &.actived{
                    background:#3CA7FE;
                    color:#fff;
                    z-index: 2;
                    &:first-child{
                        &::after{
                            border-color: transparent transparent transparent #3CA7FE;
                        }
                    }
                    &:last-child{
                        &::after{
                            border-color: transparent transparent #3CA7FE transparent;
                        }
                    }
                }
            }
        }
        .reward-list{
            padding:15px 20px;
            background:#fff;
            .reward-item{
                padding:10px 0;
                // border-bottom: 1px solid #f9f9f9;
                text-align: center;
                font-size: 14px;
                line-height: 18px;
                color:#999;
                @include flex-between();
                // .col1{
                //     width:70px;
                //     @include one-line();
                // }
                // .col2{
                //     max-width: 126px;
                //     @include one-line();
                // }
                // .col3{
                //     width:90px;
                //     @include one-line();
                // }
                & div{
                    width: 33%;
                    @include one-line();
                }
            }
        }
        .see-more{
            text-align: center;
            font-size: 12px;
            color:#999;
            line-height: 40px;
            height:40px;
            margin-top: 10px;
        }
    }
}
</style>